import { useCallback, useState } from "react";

import { BrandCustom } from "../models/brand.custom";
import { NewGridThemeKey } from "Components/AppGrid/shipeezi-new-grid";

export default function useCurrentBrand() {
  const [currentBrand, _setCurrentBrand] = useState<BrandCustom | undefined>(
    localStorage.getItem(NewGridThemeKey)
      ? JSON.parse(localStorage.getItem(NewGridThemeKey) || "")
      : undefined
  );

  const setCurrentBrand = useCallback((brandCustom?: BrandCustom) => {
    if (brandCustom) {
      localStorage.setItem(NewGridThemeKey, JSON.stringify(brandCustom));
    } else {
      localStorage.removeItem(NewGridThemeKey);
    }
    _setCurrentBrand(brandCustom);
  }, []);

  return { currentBrand, setCurrentBrand } as const;
}
